import React from 'react';
import classNames from 'classnames';
import Input from '@mui/material/Input';
import styles from 'components/admin/deviceDashboard/deviceEditor/DeviceSimulator.module.scss';

const TransactionAmountSelection = (props) => {
  const { onBack, onNext, selectedTransactionAmountInDollars, setSelectedTransactionAmount } = props;

  return (
    <>
      <header className={styles.header}>
        <h4>Choose your transaction amount</h4>
      </header>
      <main className={styles.main}>
        <section className={styles.section}>
          <p>
            How much do you want this turn to cost? We are trusting you to please use a realistic
            number. Please note: this value must be in DOLLARS, not cents.
          </p>
          <Input
            required
            id="transaction-amount"
            label="Transaction Amount"
            onChange={(event) => {
              setSelectedTransactionAmount(parseInt(event.target.value));
            }}
            sx={{ width: '100px' }}
            value={selectedTransactionAmountInDollars ? selectedTransactionAmountInDollars.toString() : ''}
            type={'number'}
          />
        </section>
      </main>
      <footer className={styles.footer}>
        <p className={styles.backButton} onClick={onBack}>
          Back
        </p>
        <button
          className={classNames(styles.backButton, {
            disabled: !selectedTransactionAmountInDollars,
          })}
          disabled={!selectedTransactionAmountInDollars}
          onClick={onNext}
        >
          Next
        </button>
      </footer>
    </>
  );
};

export default TransactionAmountSelection;
